module.exports = __webpack_public_path__ + "media/images/project/arrow-up-thin-beb05ab882b52a7bf235d6216541d521.svg";